import {ObvioEvent} from 'Event'
import {Client} from 'lib/ui/api-client'
import {api} from 'lib/url'
import {useQuery} from 'react-query'

export type ObieHub = {
  id: string
  name: string
  slug: string
}

export function useObieHubs(params: {client: Client; event: ObvioEvent}) {
  const {client, event} = params

  return useQuery<ObieHub[], {message: string}>({
    queryKey: ['events', event.id, 'integrations', 'obie', 'hubs'],
    queryFn: () =>
      client.get<ObieHub[]>(api(`/events/${event.id}/integrations/obie/hubs`)),
  })
}
